import TagManager from 'react-gtm-module';
import getConfig from 'next/config';
import debounce from 'lodash.debounce';
import { DataLayer } from '../../types/analytics';
import { DATA_LAYER_DEFAULT_EVENT } from '../../constant';
import { formatUnleashVariantsForDataLayer } from '../unleash';
import { UnleashSessionVariants } from '../unleash/unleash.types';

const runtimeConfig = getConfig() || {};
const GTM = runtimeConfig.publicRuntimeConfig?.GTM || { gtmId: '' };

let unleashVariants: UnleashSessionVariants;
let unleashId: number | undefined;

export const analytics = (analyticsData: DataLayer, shouldAutoClear = true) => {
  window.dataLayer = window.dataLayer || [];
  const finalAnalyticsData: any = analyticsData;

  if (
    unleashVariants &&
    finalAnalyticsData?.event &&
    finalAnalyticsData?.event === 'virtual page view'
  ) {
    const experiments = formatUnleashVariantsForDataLayer(unleashVariants);
    finalAnalyticsData.unleash = experiments;
    finalAnalyticsData.unleashSessionId = unleashId;
  }

  window?.dataLayer?.push({ ...finalAnalyticsData, _clear: shouldAutoClear });

  return analyticsData;
};

export const pushDataLayerTags = ({
  googleAnalyticsPageName: pageName = '',
  googleAnalyticsPageType: pageType = '',
  googleAnalyticsPageSubType: pageSubType = '',
  id: pageId = '',
  event = DATA_LAYER_DEFAULT_EVENT,
} = {}) => {
  const analyticsData = {
    event,
    pageId,
    pageName: pageName.toLowerCase(),
    pageSubType: pageSubType.toLowerCase(),
    pageType: pageType.toLowerCase(),
  };

  if (pageId) window?.dataLayer?.push({ ...analyticsData });
};

export const initializeGtm = (
  children: { props: any },
  unleashSessionVariants: UnleashSessionVariants | null,
  unleashSessionId?: number,
) => {
  if (GTM && GTM.gtmId) TagManager.initialize(GTM);
  const { content } = children?.props || {};
  pushDataLayerTags(content);

  if (unleashSessionVariants) {
    unleashVariants = unleashSessionVariants;
    unleashId = unleashSessionId;
  }
};

export const debounceDataLayerEvent = debounce((func: () => void) => {
  func();
}, 500);
